import axios from 'axios';
import config from './config.json';

export const loadUser = async () => {
  let data;

  ({ data } = {
    data: await axios({
      method: 'get',
      url: `${config.saml.userInfoUrl}`,
      withCredentials: true,
    }),
  });
  return data.data.user;
};

export const logout = async () => {
  let data;
  ({ data } = {
    data: await axios({
      method: 'post',
      url: `${config.saml.logoutCallbackUrl}`,
      withCredentials: true,
    }),
  });
  return data;
};
